import { exists } from '../runtime.js';
import './ApiActivityType.js';
import './ApiAdditionalInfoType.js';
import './ApiAirportType.js';
import './ApiBaggageType.js';
import './ApiBaggageUnitType.js';
import { ApiBaseDataFromJSON, ApiBaseDataToJSON } from './ApiBaseData.js';
import './ApiBaseDataSource.js';
import { ApiBestPriceRoomFromJSON, ApiBestPriceRoomToJSON } from './ApiBestPriceRoom.js';
import './ApiBookingAction.js';
import './ApiBookingState.js';
import './ApiCabinClass.js';
import './ApiCamperFeatureType.js';
import './ApiClientType.js';
import { ApiComponentInfoFromJSON, ApiComponentInfoToJSON } from './ApiComponentInfo.js';
import './ApiComponentPriceType.js';
import './ApiComponentType.js';
import './ApiConfigurationDataType.js';
import './ApiDebitType.js';
import './ApiDirection.js';
import './ApiDistanceUnit.js';
import './ApiDocumentSubType.js';
import './ApiDocumentType.js';
import { ApiDurationInfoFromJSON, ApiDurationInfoToJSON } from './ApiDurationInfo.js';
import './ApiDurationType.js';
import './ApiFilterCategory.js';
import './ApiFilterType.js';
import './ApiFuelType.js';
import './ApiGender.js';
import { ApiGeoAssignmentFromJSON, ApiGeoAssignmentToJSON } from './ApiGeoAssignment.js';
import { ApiGeoUnitFromJSON, ApiGeoUnitToJSON } from './ApiGeoUnit.js';
import { ApiImageContainerFromJSON, ApiImageContainerToJSON } from './ApiImageContainer.js';
import './ApiImageType.js';
import { ApiInternalInfoFromJSON, ApiInternalInfoToJSON } from './ApiInternalInfo.js';
import './ApiInventory.js';
import { ApiItemFromJSONTyped, ApiItemToJSON } from './ApiItem.js';
import './ApiItemType.js';
import { ApiMediaFromJSON, ApiMediaToJSON } from './ApiMedia.js';
import './ApiNoteOriginType.js';
import './ApiNoteType.js';
import './ApiPackagePriceComponentType.js';
import './ApiPaymentDataType.js';
import './ApiPaymentOption.js';
import './ApiPaymentState.js';
import { ApiPriceFromJSON, ApiPriceToJSON } from './ApiPrice.js';
import './ApiPriceModifierType.js';
import './ApiPriceType.js';
import './ApiRecommendationServiceType.js';
import './ApiRelatedServiceRelationType.js';
import './ApiRole.js';
import './ApiRowCharacteristics.js';
import './ApiSeatCharacteristics.js';
import './ApiServiceSelectionType.js';
import './ApiSortDirection.js';
import './ApiSortOption.js';
import './ApiSpecialRequestGroup.js';
import './ApiStaticContentType.js';
import './ApiTaxDisplay.js';
import './ApiTransmissionType.js';
import './ApiTravelStatusEnum.js';
import './ApiTravelerType.js';
import './ApiVoucherDeliveryType.js';
import './ApiWalletType.js';

/* tslint:disable */
function ApiBestPricePackageModelFromJSON(json) {
    return ApiBestPricePackageModelFromJSONTyped(json, false);
}
function ApiBestPricePackageModelFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        ...ApiItemFromJSONTyped(json, ignoreDiscriminator),
        'code': json['code'],
        'typeCode': json['typeCode'],
        'serviceCode': json['serviceCode'],
        'serviceTypeCode': json['serviceTypeCode'],
        'media': !exists(json, 'media') ? undefined : ApiMediaFromJSON(json['media']),
        'hotelLogo': !exists(json, 'hotelLogo') ? undefined : ApiImageContainerFromJSON(json['hotelLogo']),
        'startDate': (json['startDate']),
        'endDate': (json['endDate']),
        'duration': ApiDurationInfoFromJSON(json['duration']),
        'origin': json['origin'],
        'originName': !exists(json, 'originName') ? undefined : json['originName'],
        'possibleOrigins': !exists(json, 'possibleOrigins') ? undefined : (json['possibleOrigins'].map(ApiGeoUnitFromJSON)),
        'price': ApiPriceFromJSON(json['price']),
        'cmsCode': !exists(json, 'cmsCode') ? undefined : json['cmsCode'],
        'category': !exists(json, 'category') ? undefined : ApiBaseDataFromJSON(json['category']),
        'description': json['description'],
        'shortDescription': !exists(json, 'shortDescription') ? undefined : json['shortDescription'],
        'listDescription': !exists(json, 'listDescription') ? undefined : json['listDescription'],
        'inclusions': !exists(json, 'inclusions') ? undefined : json['inclusions'],
        'geoAssignment': !exists(json, 'geoAssignment') ? undefined : ApiGeoAssignmentFromJSON(json['geoAssignment']),
        'vacancyInfo': !exists(json, 'vacancyInfo') ? undefined : json['vacancyInfo'],
        'characteristics': !exists(json, 'characteristics') ? undefined : (json['characteristics'].map(ApiBaseDataFromJSON)),
        'rooms': (json['rooms'].map(ApiBestPriceRoomFromJSON)),
        'options': (json['options'].map(ApiBaseDataFromJSON)),
        'smallGroup': !exists(json, 'smallGroup') ? undefined : json['smallGroup'],
        'availability': !exists(json, 'availability') ? undefined : json['availability'],
        'componentTypes': (json['componentTypes'].map(ApiComponentInfoFromJSON)),
        'internalInfo': !exists(json, 'internalInfo') ? undefined : ApiInternalInfoFromJSON(json['internalInfo']),
        'stationCodes': !exists(json, 'stationCodes') ? undefined : json['stationCodes'],
    };
}
function ApiBestPricePackageModelToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...ApiItemToJSON(value),
        'code': value.code,
        'typeCode': value.typeCode,
        'serviceCode': value.serviceCode,
        'serviceTypeCode': value.serviceTypeCode,
        'media': ApiMediaToJSON(value.media),
        'hotelLogo': ApiImageContainerToJSON(value.hotelLogo),
        'startDate': (value.startDate),
        'endDate': (value.endDate),
        'duration': ApiDurationInfoToJSON(value.duration),
        'origin': value.origin,
        'originName': value.originName,
        'possibleOrigins': value.possibleOrigins === undefined ? undefined : (value.possibleOrigins.map(ApiGeoUnitToJSON)),
        'price': ApiPriceToJSON(value.price),
        'cmsCode': value.cmsCode,
        'category': ApiBaseDataToJSON(value.category),
        'description': value.description,
        'shortDescription': value.shortDescription,
        'listDescription': value.listDescription,
        'inclusions': value.inclusions,
        'geoAssignment': ApiGeoAssignmentToJSON(value.geoAssignment),
        'vacancyInfo': value.vacancyInfo,
        'characteristics': value.characteristics === undefined ? undefined : (value.characteristics.map(ApiBaseDataToJSON)),
        'rooms': (value.rooms.map(ApiBestPriceRoomToJSON)),
        'options': (value.options.map(ApiBaseDataToJSON)),
        'smallGroup': value.smallGroup,
        'availability': value.availability,
        'componentTypes': (value.componentTypes.map(ApiComponentInfoToJSON)),
        'internalInfo': ApiInternalInfoToJSON(value.internalInfo),
        'stationCodes': value.stationCodes,
    };
}

export { ApiBestPricePackageModelFromJSON, ApiBestPricePackageModelFromJSONTyped, ApiBestPricePackageModelToJSON };
//# sourceMappingURL=ApiBestPricePackageModel.js.map
